<script lang="ts" setup>
import MItemSection from "../../MItemSection";
import MIcon from "../../MIcon";
import MItem from "../../MItem";
import { ItemOption } from "./_types";
import MAvatar from "../../MAvatar";

defineProps<{
  item: ItemOption;
  selected?: boolean;
  hasPhoto?: boolean;
  disabled?: boolean;
}>();
</script>
<template>
  <MItem class="select-item" :disabled="disabled">
    <slot name="section" v-bind="{ option: item }" />
    <m-item-section v-if="hasPhoto" avatar>
      <m-avatar :photo-url="item.photoUrl" :name="item.label" />
    </m-item-section>
    <m-icon v-else-if="item.icon" color="black" class="m-mr-sm" :name="item.icon" />
    <m-item-section
      :class="[
        item.color && `color-${item.color}`,
        item.description && 'm-select-item-with-description',
      ]"
    >
      <div v-if="item.description">
        <p class="m-select-item-label">
          {{ item.label }}
        </p>
        <template v-if="Array.isArray(item.description)">
          <p
            v-for="d in item.description"
            :key="`${item.label}.${d}`"
            class="m-select-item-description"
          >
            {{ d }}
          </p>
        </template>

        <p v-else class="m-select-item-description">
          {{ item.description }}
        </p>
      </div>
      <template v-else>
        {{ item.label }}
      </template>
    </m-item-section>

    <m-item-section v-if="selected" avatar>
      <m-icon name="fa-light fa-check" color="black" />
    </m-item-section>
    <slot v-if="$slots['option-action']" name="option-action" v-bind="item" />
  </MItem>
</template>
<style lang="scss">
.select-item {
  .m-item-section--avatar > .m-icon {
    font-size: 16px;
  }
}
</style>
